import { SupplyPhases } from "../../../components/submitApplication/single/types/formGeneratorTypes"
import {
    DnoApplicationTypes,
    Datasets,
    LCTOnlyDatasets,
} from "../../../constants/enums"
import { ASSESSMENT_TYPE_KW } from "../../../constants/generalConstants"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG
const HYBRID_BASE = CONFIG.HYBRID_API_URL

const LCT_V1 = `${HYBRID_BASE}/lct/v1`
const TTR_V1 = `${HYBRID_BASE}/ttr/v1`
const DNO_V1 = `${HYBRID_BASE}/dno-application/v1`
const DNO_V2 = `${HYBRID_BASE}/dno-application/v2`
const DNO_SOL_V1 = `${HYBRID_BASE}/dno-sol/v1`
const INSTALLER_V1 = `${HYBRID_BASE}/connection-application/v1`
const UPLOAD_ATTACH_V1 = `${HYBRID_BASE}/upload-attachment/v1`
const DOCS = `${HYBRID_BASE}/openapi.json`
const AUTOCOMPLETE = `${HYBRID_BASE}/location/v1/autocomplete`
const COMPANY_SEARCH = `${HYBRID_BASE}/company-search/v1/company-search`
const COMMISSIONING = `${HYBRID_BASE}/commissioning/v1`
const DNO_COMMISSIONING = `${HYBRID_BASE}/dno-commissioning/v2`
const DRAFTS = `${HYBRID_BASE}/draft/v1`

// LCT / TTR apis
const SEARCH_GEN_DEVICES = (
    searchParams: string,
    protectedRoute: boolean
): string =>
    `${LCT_V1}/ttr-search${protectedRoute ? "-protected" : ""}${
        searchParams ? `?${searchParams.toString()}` : ""
    }`

const SEARCH_DEMAND_DEVICES = (
    searchParams: string,
    dataset: LCTOnlyDatasets,
    protectedRoute: boolean
): string =>
    `${LCT_V1}/lct-search${
        protectedRoute ? "-protected" : ""
    }?dataset=${dataset}${searchParams ? `&${searchParams.toString()}` : ""}`
const SINGLE_DEVICE = (
    deviceId: string,
    dataset: Datasets,
    protectedRoute: boolean
): string =>
    `${LCT_V1}/device${
        protectedRoute ? "-protected" : ""
    }?device_sys_ref=${deviceId}&dataset=${dataset}`

const GEN_REFERENCE = (protectedRoute: boolean): string =>
    `${LCT_V1}/ttr-reference${protectedRoute ? "-protected" : ""}`

const DEMAND_REFERENCE = (dataset: LCTOnlyDatasets): string =>
    `${LCT_V1}/lct-reference?dataset=${dataset}`

const FULL_DEVICE = (deviceRef: string, dataset: Datasets): string =>
    `${LCT_V1}/full-device-protected?dataset=${dataset}&device_sys_ref=${deviceRef}`

const DOWNLOAD = (dataset: Datasets): string =>
    `${LCT_V1}/download-protected?dataset=${dataset}`

const SUGGEST_DEVICE = (
    searchParams: string,
    deviceType: string,
    dataset: Datasets,
    jurisdiction: string,
    phases?: SupplyPhases
): string => {
    let url = `${LCT_V1}/device-suggestions?dataset=${dataset}&search_term=${encodeURIComponent(
        searchParams
    )}&device_type=${deviceType}&jurisdiction=${jurisdiction}`

    if (phases) {
        url += `&phases=${phases}`
    }

    return url
}

// DNO interface APIs
const DNO_ATTACHMENT = (applicationId: string, attachmentId: string): string =>
    `${DNO_V1}/attachment?applicationId=${applicationId}&attachmentId=${encodeURIComponent(
        attachmentId
    )}`
const RESPOND_TO_APPLICATION = `${DNO_V1}/respond`
const DNO_LIST_APPLICATIONS = (
    searchParams: string,
    limit: number,
    sortKey: string
): string => {
    // const sortKeyParam = sortKey ? `&sort_key=${sortKey}` : ""
    const searchParamsParam = searchParams ? `${searchParams}` : ""
    const base = `${HYBRID_BASE}/dno-application/v3`
    return `${base}/applications?limit=${limit}${
        searchParamsParam ? `&${searchParamsParam}` : ""
    }`
}

const DNO_LIST_APPLICATIONS_MONTHLY = (
    searchParams: string,
    limit: number,
    updatedSince: string,
    updatedTo: string
): string => {
    const searchParamsParam = searchParams ? `&${searchParams}` : ""
    return DNO_LIST_APPLICATIONS(
        `updatedSince=${encodeURIComponent(updatedSince)}&updatedTo=${encodeURIComponent(updatedTo)}&sort_key=updatedSince${searchParamsParam}`,
        limit,
        updatedSince
    )
}

const DNO_SINGLE_APPLICATION = (applicationId: string): string =>
    DNO_LIST_APPLICATIONS(
        `applicationId=${applicationId}&${ASSESSMENT_TYPE_KW}=${DnoApplicationTypes.all}`,
        100,
        ""
    )

const DNO_SOL_NOTIFICATIONS = (
    searchParams: string,
    limit: number,
    ascending: string
): string => {
    const searchParamsParam = searchParams ? `${searchParams}&` : ""
    return `${DNO_SOL_V1}/notifications?${searchParamsParam}ascending=${ascending}&limit=${limit}`
}

// Location APIs
const ADDRESS_SUGGESTION = (
    searchTerm: string,
    houseNo: string,
    worldwide: boolean
): string =>
    `${AUTOCOMPLETE}?` +
    `search_text=${searchTerm}&` +
    `house_no=${houseNo}&` +
    `worldwide=${worldwide}`

// Installer APIs
const GET_SCHEMA = (lcts: string[]): string => {
    const baseUrl = `${INSTALLER_V1}/schema`
    const lctParams = lcts
        .map((lct) => `lcts=${encodeURIComponent(lct)}`)
        .join("&")
    return `${baseUrl}?${lctParams}&show_details=true`
}
const INSTALLER_ATTACHMENT_UPLOAD = `${UPLOAD_ATTACH_V1}/upload`
const INSTALLER_LIST_APPLICATIONS = (
    searchParams: string,
    limit: number,
    sortKey: string
): string => {
    const sortKeyParam = sortKey ? `&sort_key=${sortKey}` : ""
    const searchParamsParam = searchParams ? `&${searchParams}` : ""
    const installerBase = `${HYBRID_BASE}/connection-application/v3`
    const apiUrl = `${installerBase}/applications?limit=${limit}${
        searchParamsParam ? `${searchParamsParam}` : ""
    }`
    return apiUrl
}

const INSTALLER_LIST_APPLICATIONS_MONTHLY = (
    searchParams: string,
    limit: number,
    updatedSince: string,
    updatedTo: string
): string => {
    const searchParamsParam = searchParams ? `&${searchParams}` : ""
    return INSTALLER_LIST_APPLICATIONS(
        `updatedSince=${encodeURIComponent(updatedSince)}&updatedTo=${encodeURIComponent(updatedTo)}&sort_key=lastUpdated${searchParamsParam}`,
        limit,
        updatedSince
    )
}

const INSTALLER_SINGLE_APPLICATION = (applicationId: string): string =>
    INSTALLER_LIST_APPLICATIONS(`applicationId=${applicationId}`, 100, "")
const CREATE_APPLICATION = `${INSTALLER_V1}/create`
const INSTALLER_LAUNCH_AMENDMENT = (applicationId: string): string =>
    `${INSTALLER_V1}/launch-amendment?applicationId=${applicationId}`
const INSTALLER_SUBMIT_AMENDMENT = (applicationId: string): string =>
    `${INSTALLER_V1}/amend?applicationId=${applicationId}`
const INSTALLER_ATTACHMENT = (
    applicationId: string,
    attachmentId: string
): string =>
    `${INSTALLER_V1}/attachment?applicationId=${applicationId}&attachmentId=${encodeURIComponent(
        attachmentId
    )}`

const DNO_ADD_COMMENT = (applicationId: string): string =>
    `${DNO_V1}/add-comment?applicationId=${applicationId}`
const DNO_DELETE_COMMENT = (applicationId: string, commentId: string): string =>
    `${DNO_V1}/delete-comment?applicationId=${applicationId}&commentId=${commentId}`
const DNO_SUBSCRIBE_DEVICE = (
    deviceSystemRef: string,
    dataset: string,
    isSubscribed: boolean
): string =>
    `${DNO_V1}/device-subscription?deviceSysRef=${deviceSystemRef}&device_type=${dataset}&toggleSubscribeToDevice=${isSubscribed}`

const INSTALLER_ADD_COMMENT = (applicationId: string): string =>
    `${INSTALLER_V1}/add-comment?applicationId=${applicationId}`
const INSTALLER_DELETE_COMMENT = (
    applicationId: string,
    commentId: string
): string =>
    `${INSTALLER_V1}/delete-comment?applicationId=${applicationId}&commentId=${commentId}`

// Drafts
const LAUNCH_DRAFT = (draftId: string): string =>
    `${DRAFTS}/launch-draft?draft_id=${draftId}`
const SUBMIT_DRAFT_FORM = `${DRAFTS}/create-draft`
const DELETE_DRAFT = (draftId: string): string =>
    `${DRAFTS}/delete-draft?draft_id=${draftId}`
const INSTALLER_LIST_DRAFT_APPLICATIONS = (
    searchParams: string,
    limit: number
): string => {
    const searchParamsParam = searchParams ? `&${searchParams}` : ""
    return `${DRAFTS}/list-drafts?limit=${limit}${searchParamsParam}`
}

// Company search
const COMPANY_SEARCH_API = (searchTerm: string): string =>
    `${COMPANY_SEARCH}?search_term=${searchTerm}`

// Docs
const HYBRID_API_DOCS = DOCS

// Commissioning
const LAUNCH_CX_FORM = (applicationId: string): string =>
    `${COMMISSIONING}/launch-form?applicationId=${applicationId}`
const SUBMIT_CX_FORM = `${COMMISSIONING}/submit`

// DNO Commissioning
const DNO_COMMISSIONING_RESPONSE = `${DNO_COMMISSIONING}/respond`
const DNO_EXPORT_MPAN = `${DNO_COMMISSIONING}/export-mpan`
const DNO_SOL_EXPORT_MPAN = `${DNO_SOL_V1}/export-mpan`

// Read/unread comments
const INSTALLER_READ_COMMENTS = (applicationId: string): string =>
    `${INSTALLER_V1}/thread-read-state?applicationId=${applicationId}`

const DNO_READ_COMMENTS = (applicationId: string): string =>
    `${DNO_V1}/thread-read-state?applicationId=${applicationId}`

export {
    SEARCH_GEN_DEVICES,
    SEARCH_DEMAND_DEVICES,
    SUGGEST_DEVICE,
    SINGLE_DEVICE,
    GEN_REFERENCE,
    DEMAND_REFERENCE,
    FULL_DEVICE,
    DOWNLOAD,
    DNO_ATTACHMENT,
    LAUNCH_CX_FORM,
    RESPOND_TO_APPLICATION,
    HYBRID_API_DOCS,
    INSTALLER_ATTACHMENT_UPLOAD,
    INSTALLER_LIST_APPLICATIONS,
    INSTALLER_LIST_APPLICATIONS_MONTHLY,
    CREATE_APPLICATION,
    DNO_SINGLE_APPLICATION,
    DNO_LIST_APPLICATIONS,
    INSTALLER_SINGLE_APPLICATION,
    INSTALLER_SUBMIT_AMENDMENT,
    INSTALLER_ATTACHMENT,
    INSTALLER_LAUNCH_AMENDMENT,
    SUBMIT_CX_FORM,
    COMPANY_SEARCH_API,
    ADDRESS_SUGGESTION as AUTOCOMPLETE_API,
    GET_SCHEMA,
    DNO_ADD_COMMENT,
    DNO_DELETE_COMMENT,
    INSTALLER_ADD_COMMENT,
    INSTALLER_DELETE_COMMENT,
    DNO_COMMISSIONING_RESPONSE,
    DNO_EXPORT_MPAN,
    DNO_SOL_EXPORT_MPAN,
    SUBMIT_DRAFT_FORM,
    DELETE_DRAFT,
    LAUNCH_DRAFT,
    INSTALLER_LIST_DRAFT_APPLICATIONS,
    DNO_SUBSCRIBE_DEVICE,
    INSTALLER_READ_COMMENTS,
    DNO_READ_COMMENTS,
    DNO_LIST_APPLICATIONS_MONTHLY,
    DNO_SOL_NOTIFICATIONS,
}
